// extracted by mini-css-extract-plugin
export var pointer = "index-module--pointer--hAJU9";
export var pointerflipped = "index-module--pointerflipped--n5x5o";